module.exports = __webpack_public_path__ + "img/home_conversion_image.de30d846.png";